<template>
	<div class="private-order-catalog">
		<div class="catalog-header">
			<div v-if="!isFirstLoadPage" class="catalog-title">
				<i class="bi-house-lock-fill"></i>
				<span class="label-text">Produk Wholesale</span>
			</div>
			<div v-else class="catalog-title-skeleton skeleton"></div>

			<div v-if="!isFirstLoadPage" class="catalog-filter">
				<span class="catalog-filter-label">Urutkan:</span>

				<multiselect
					class="form-control"
					v-model="sortValue"
					:options="sortOptions"
					:show-labels="false"
					:allow-empty="false"
					:preselect-first="true"
					placeholder="Pilih"
					style="width: 150px"
				></multiselect>
			</div>
			<div v-else class="catalog-filter-skeleton skeleton"></div>
		</div>

		<div class="slider-banner-wrapper d-none d-md-block">
			<slider-banner
				identity="desktop"
				additionalClass="homepage"
				:is-loading="isBannerLoading"
				:banners="banners"
			/>
		</div>

		<div class="slider-banner-wrapper d-block d-md-none">
			<slider-banner
				identity="mobile"
				additionalClass="homepage"
				:is-loading="isBannerLoading"
				:banners="banners"
			/>
		</div>

		<div v-if="!isFirstLoading" class="catalog-body">
			<private-order-catalog-card
				v-for="(item, index) in privateOrderList"
				:key="index"
				:product-image-url="handleProductImageUrl(item.pictures[0])"
				:product-name="item.name"
				:slash-price="item.distributor.slash_price"
				:city-origin="item.shipping.origin.city_name"
				:stock="parseInt(item.distributor.stock.quantity)"
				:wholesale="item.distributor.wholesale"
				:product="item"
				:slug="item.slug"
			/>
		</div>
		<div v-else class="catalog-body">
			<private-order-catalog-card v-for="(_, index) in Array(10)" :key="index" is-loading />
		</div>

		<div class="table-fetch-status" v-if="isGetListLoading">
			<div class="is-loading large dark m-auto"></div>
		</div>

		<div v-if="showEmptyState" class="empty-state-wrapper">
			<img
				class="empty-state-image"
				src="https://cdn.ostock.id/img/product-not-found.png"
				alt="empty-state-image"
			/>

			<span>Oops! Produk Tidak Ditemukan</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import PrivateOrderCatalogCard from '@/components/private-orders/homepage/CatalogCard.vue';
import SliderBanner from '@/components/private-orders/homepage/SliderBanner.vue';
import privateProductApi, { getBannerList } from '@/api/private-product';

export default {
	components: {
		PrivateOrderCatalogCard,
		SliderBanner,
	},
	data() {
		return {
			sortOptions: ['Terbaru', 'Termurah', 'Termahal'],
			sortValue: 'Terbaru',
			listParams: {
				sort_by: '',
				keyword: '',
				page: 1,
				limit: 25,
			},
			privateOrderList: [],
			isFirstLoadPage: true,
			isFirstLoading: true,
			isGetListLoading: false,
			isGetListAll: false,
			timeout: null,
			isBannerLoading: true,
			banners: [],
			limit: 20,
			page: 1,
			sort_by: 'data.sort',
			sort: 'asc',
		};
	},
	computed: {
		...mapGetters({
			keyword: 'privateOrder/keyword',
		}),
		sortBy() {
			let value = '';

			if (this.sortValue === 'Terbaru') {
				value = 'created_at';
			} else if (this.sortValue === 'Termurah') {
				value = 'lowest_price';
			} else if (this.sortValue === 'Termahal') {
				value = 'highest_price';
			} else {
				value = '';
			}

			return value;
		},
		showEmptyState() {
			return !(this.isGetListLoading || this.isFirstLoading) && !this.privateOrderList.length;
		},
	},
	watch: {
		keyword: {
			handler(newValue) {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.getList(true, newValue);
				}, 300);
			},
		},
		sortValue: {
			handler(newValue) {
				this.$router.replace({
					query: {
						...this.$route.query,
						sort: newValue,
					},
				});

				this.getList(true, this.keyword);
			},
		},
	},
	methods: {
		getList(isReset = true, keyword) {
			if (isReset) {
				this.isFirstLoading = true;
				this.privateOrderList = [];
				this.listParams.page = 1;
				this.isGetListAll = false;
			} else {
				this.isGetListLoading = true;
			}

			const params = this.listParams;
			params.keyword = keyword;
			params.sort_by = this.sortBy;

			const cb = (response) => {
				this.privateOrderList =
					this.listParams.page === 1
						? response.data
						: [...this.privateOrderList, ...response.data];

				if (response.data.length > 0) {
					this.listParams.page += 1;
				} else {
					this.isGetListAll = true;
				}

				this.isFirstLoadPage = false;
				this.isFirstLoading = false;
				this.isGetListLoading = false;
			};

			const err = () => {
				this.isFirstLoadPage = false;
				this.isFirstLoading = false;
				this.isGetListLoading = false;
			};

			privateProductApi.getList(params, cb, err);
		},
		handleProductImageUrl(url) {
			if (!url) {
				return 'https://cdn.ostock.id/img/default-product.png';
			}
			return url;
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom && !this.isFirstLoading) {
				if (!this.isGetListLoading && !this.isGetListAll) {
					this.getList(false, this.keyword);
				}
			}
		},
		fetchBanners() {
			this.isBannerLoading = true;

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			const callback = (response) => {
				const banners = response.data;
				this.banners = banners;
				this.isBannerLoading = false;
			};

			const errorCallback = () => {
				this.isBannerLoading = false;
			};

			getBannerList(params, callback, errorCallback);
		},
	},
	mounted() {
		if (this.$route.query !== null) {
			this.sortValue = this.$route.query?.sort ? this.$route.query.sort : 'Terbaru';
			if (!this.$route.query?.sort || this.$route.query.sort === 'Terbaru') {
				this.getList(true, this.keyword);
			}
		}

		this.fetchBanners();

		window.addEventListener('scroll', this.handleScroll);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped lang="scss">
.private-order-catalog {
	position: relative;
	margin-top: 0;
	width: 100%;
	height: auto;
	min-height: 60vh;
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.catalog-header {
	width: 100%;
	height: 60px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: #f3f4f5;
	padding: 0 16px;

	@media screen and (min-width: 600px) {
		height: 72px;
	}

	@media screen and (min-width: 768px) {
		padding: 0 50px;
	}

	@media screen and (min-width: 992px) {
		padding: 0 80px;
	}

	@media screen and (min-width: 1200px) {
		padding: 0 120px;
	}

	@media screen and (min-width: 1680px) {
		padding: 0 calc((100% - 1440px) / 2);
	}
}

.catalog-title {
	display: flex;
	gap: 10px;
	font-size: 16px;
	font-weight: 700;
	align-items: center;

	@media screen and (min-width: 768px) {
		font-size: 22px;
		font-weight: 700;
		gap: 18px;
	}
}

.catalog-title-skeleton {
	width: 160px;
	height: 30px;
}

.catalog-filter-label {
	display: none;

	@media screen and (min-width: 426px) {
		display: block;
	}
}

.catalog-filter {
	display: flex;
	gap: 8px;
	align-items: center;
}

.catalog-filter-skeleton {
	width: 200px;
	height: 30px;
}

.slider-banner-wrapper {
	width: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 10px;

	@media screen and (min-width: 426px) {
		padding: 0 16px;
		margin: 20px 0;
	}

	@media screen and (min-width: 768px) {
		padding: 0 50px;
	}

	@media screen and (min-width: 992px) {
		padding: 0 80px;
	}

	@media screen and (min-width: 1200px) {
		padding: 0 120px;
	}

	@media screen and (min-width: 1680px) {
		padding: 0 calc((100% - 1440px) / 2);
	}
}

.table-fetch-status {
	margin-top: 120px;
}

.catalog-body {
	display: grid;
	gap: 10px;
	grid-template-columns: repeat(2, minmax(0px, 1fr));
	margin-bottom: 24px;
	padding: 0 10px;

	@media screen and (min-width: 426px) {
		padding: 0 16px;
		gap: 24px;
	}

	@media screen and (min-width: 768px) {
		grid-template-columns: repeat(3, minmax(0px, 1fr));
		padding: 0 50px;
	}

	@media screen and (min-width: 992px) {
		grid-template-columns: repeat(4, minmax(0px, 1fr));
		padding: 0 80px;
	}

	@media screen and (min-width: 1200px) {
		grid-template-columns: repeat(5, minmax(0px, 1fr));
		padding: 0 120px;
	}

	@media screen and (min-width: 1680px) {
		padding: 0 calc((100% - 1440px) / 2);
	}
}

.empty-state-wrapper {
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 120px;
	gap: 16px;

	& > img.empty-state-image {
		width: 50%;
		max-width: 350px;
	}

	& > span {
		font-weight: 600;
		font-size: 18px;
		line-height: 24px;
	}
}

.skeleton {
	margin-bottom: 0;
}
</style>
